import ApiClient from "../helpers/ApiClient";

const listLinks = (params) =>
  ApiClient.apiClientDef.get(`/base/links_ajuda`, {
    params,
  });

const postLinks = (data) =>
  ApiClient.apiClientDef.post(`/base/links_ajuda`, data);

const putLinks = (uid, data) =>
  ApiClient.apiClientDef.put(`/base/links_ajuda/${uid}`, data);

const deleteLinks = (uid) =>
  ApiClient.apiClientDef.delete(`/base/links_ajuda/${uid}`);

const getLink = (uid) =>
  ApiClient.apiClientDef.get(`/base/links_ajuda/${uid}`);

const linksAjudaApiClient = {
  listLinks,
  postLinks,
  putLinks,
  deleteLinks,
  getLink,
};
export default linksAjudaApiClient;
